var $d80f30fe86c95741$exports = {};
$d80f30fe86c95741$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\xa0: ${args.value}`,
    "colorPicker": `S\xe9lecteur de couleurs`,
    "colorSwatch": `\xc9chantillon de couleurs`,
    "transparent": `Transparent`,
    "twoDimensionalSlider": `Curseur\xa02D`
};


export {$d80f30fe86c95741$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
